import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white" data-id="element-79" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-4 py-6 sm:px-6 sm:py-8" data-id="element-80" data-mp="9ttj2hqfwb1t">
        <Reveal className="flex items-start gap-3 rounded-2xl border-2 border-navy p-4" data-id="element-81" data-mp="9wph062aezq9">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-82" data-mp="ercwxgj86lt8">
            <ShieldCheckIcon size={26} className="text-navy" aria-hidden="true" data-id="element-83" data-mp="jqpuav7q3ba2" />
          </span>
          <div data-id="element-84" data-mp="nrrjskbu88yu">
            <p className="font-display text-xs font-bold uppercase text-graphite-muted" data-id="element-85" data-mp="skuj793aqcmy">
              Tu inversión está protegida
            </p>
            <h2 id="garantia" className="font-display text-lg font-extrabold leading-tight text-navy sm:text-xl" data-id="element-86" data-mp="xim95xkdrooi">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-1 text-[0.8rem] leading-snug text-graphite-muted sm:text-sm" data-id="element-87" data-mp="17id39y5141o2">
              Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si consideras
              que el sistema no es adecuado para ti, puedes solicitar un reembolso
              dentro del período establecido según los términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}